"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("tippy.js/dist/tippy.css");
var react_1 = __importDefault(require("react"));
var react_jss_1 = require("react-jss");
var react_2 = __importDefault(require("@tippyjs/react"));
var __1 = require("..");
var classnames_1 = __importDefault(require("classnames"));
var defaultProps = {
    hideArrow: false,
    disabled: false,
    theme: 'dark',
    size: 'sm',
};
var useStyles = (0, react_jss_1.createUseStyles)(function (_a) {
    var colors = _a.colors;
    return ({
        tooltip: {
            boxSizing: 'border-box',
            color: colors.Grey[0],
            backgroundColor: colors.Grey['700'],
            '& .tippy-arrow': {
                color: colors.Grey['700'],
            },
            '&[data-placement^=right] .tippy-arrow:before': {
                left: -6,
                borderWidth: '6px 6px 6px 0',
            },
            '&[data-placement^=left] .tippy-arrow:before': {
                borderWidth: '6px 0 6px 7px',
                right: -6,
            },
            '&[data-placement^=top] .tippy-arrow:before': {
                borderWidth: '6px 6px 0 6px',
                bottom: -6,
            },
            '&[data-placement^=bottom] .tippy-arrow:before': {
                borderWidth: '0 6px 6px 6px',
                top: -6,
            },
        },
        hideArrow: {
            '& .tippy-arrow': {
                display: 'none',
            },
        },
        lightTheme: {
            color: colors.Grey['900'],
            backgroundColor: colors.Grey[0],
            boxShadow: '0px 1px 8px rgba(0, 0, 0, 0.1)',
            '& .tippy-arrow': {
                color: colors.Grey[0],
            },
        },
        sm: {
            '& .tippy-content': {
                maxWidth: 154,
                padding: '7px 12px',
            },
        },
        md: {
            '& .tippy-content': {
                maxWidth: 272,
                padding: '10px 12px 12px',
            },
        },
    });
});
var Tooltip = function (_a) {
    var text = _a.text, children = _a.children, className = _a.className, hideArrow = _a.hideArrow, theme = _a.theme, size = _a.size, rest = __rest(_a, ["text", "children", "className", "hideArrow", "theme", "size"]);
    var styles = useStyles();
    return (react_1.default.createElement(react_2.default, __assign({ className: (0, classnames_1.default)(styles.tooltip, !!className && className, !!hideArrow && styles.hideArrow, theme === 'light' && styles.lightTheme, styles[size || 'sm']), content: react_1.default.createElement(__1.Typography, { margin: 'none', component: "span", variant: 'textSmall' }, text) }, rest), children));
};
Tooltip.defaultProps = defaultProps;
exports.default = Tooltip;
//# sourceMappingURL=index.js.map